module.exports = __webpack_public_path__ + "perivascular-spaces.4853150aecccac127dcb87a4c6697e54.png";